import { createContext, useContext } from "react";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { GoogleFreeBookingLinksSettingsZodSchemaType } from "../../../hooks";
import type { UseFormReturn } from "react-hook-form";

export type GoogleFreeBookingLinksSettingsContextType = {
	form: UseFormReturn<GoogleFreeBookingLinksSettingsZodSchemaType>;
	connectablePlanList: Array<FormOptionType>;
	connectableRoomList: Array<FormOptionType>;
	isShowHpbGuestPageTypeOption: boolean;
};

export const GoogleFreeBookingLinksSettingsContext = createContext<GoogleFreeBookingLinksSettingsContextType>(null!);

export const useGoogleFreeBookingLinksSettingsContext = () => {
	const context = useContext(GoogleFreeBookingLinksSettingsContext);

	if (!context) {
		throw new Error("GoogleFreeBookingLinksSettingsContext is not defined");
	}

	return context;
};
